import { fetchDrmTableData } from "../../service/fetchDrmTableData";
import { setCoupaFilesDeleteDetailsSuccess, setCoupaFilesDeleteDetailsFailure } from "../reducers/drmCoupaFIleDeleteDetailsSlice";
import { put, takeLatest, call, cancelled } from "redux-saga/effects";
import { ENUM_DATA } from "../../constData/enum";

export function* workerGetCoupaFilesDeleteDetails({ payload }) {
    const controller = new AbortController();
    try {
        const response = yield call(fetchDrmTableData, [
            payload.pageNum,
            payload.reqBody,
            payload.pageSize,
            payload.tableName,
            controller,
        ]);

        const data = response.data;
        const formattedData = data?.details?.data?.map((item) => (item)) || [];

        yield put(
            setCoupaFilesDeleteDetailsSuccess({
                drmCoupaFileDeleteDetails: formattedData,
                onPage: data?.details?.onPage ?? 0,
                pageSize: data?.details?.pageSize ?? 0,
                totalPages: data?.details?.totalPages ?? 0,
                totalRecords: data?.details?.totalRecords ?? 0,
            })
        );
    } catch (error) {
        yield put(setCoupaFilesDeleteDetailsFailure(error.toString() || ENUM_DATA.Blank));
    } finally {
        if (yield cancelled()) {
            controller.abort();
        }
    }
}

function* drmCoupaFileDeleteDetailsSaga() {
    yield takeLatest("drmcoupaFileDeleteDetails/getCoupaFilesDeleteDetails", workerGetCoupaFilesDeleteDetails);
}

export default drmCoupaFileDeleteDetailsSaga;